app.service("ProductHettichService", ['$rootScope', 'ProductService', function ($rootScope, ProductService) {

    const siteHelper = $rootScope.site_helper;
    const modelConstructor = $rootScope.model_constructor;

    const ProductHettichModel = modelConstructor.extend(ProductService.BasicProductModel, {
        id: "product_hettich",
        dataResponseHandler: dataResponseHandler,
        applyItemHandler: applyItemHandler,
        base_component_id: "hettich"

    });

    this.factory = new ProductService.BasicProductModelFactory({
        validVariationPointers: function (variationIDs) {
            return [];
        },
        birth: function (values) {
            return new ProductHettichModel(values);
        }
    });

    function applyItemHandler(product) {
        this.super(product);

        let localOptionTermConfig = [];
        if (product.requires_colour && product.colours) {
            localOptionTermConfig = localOptionTermConfig.concat([
                {
                    option_id: "hettich_colour",
                    required: true
                }
            ])
        }
        if (product.push_to_open && product.soft_close) {
            localOptionTermConfig = localOptionTermConfig.concat([
                {
                    option_id: "hinge_option",
                    required: false
                }
            ])
        }

        product.local_option_term_config = localOptionTermConfig;
        product.group_name = product.name;

        siteHelper.applyValues(product, {

            option_layout: "list",
            quantity: 1,
            readable_api_code: product.api_code ? product.api_code.replace("*SC-", '') : "",

            collectImageParams: function () {
                const params = this.super();

                params.image_type_id = "product";
                params.site_range_id = "bella";
                params.api_code = "stock";
                params.product_code = product.api_code;
                params.width = 250;
                params.height = 250;

                return params;
            },

            finalPrice: function () {
                return finalPrice(product);
            }
        });
    }

    function dataResponseHandler(data) {
        return data.products ? data.products : {}
    }

    function finalPrice(product) {
        return $rootScope.service.product.appliedMinimumDiscountPrice(product, product.base_price);
    }

}])